"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
exports.rowHeight = 32;
const Container = styled_1.default("div")(({ condensed, disabled, align, theme, width }) => {
    return {
        userSelect: "none",
        label: "contextmenuitem",
        width: width || "100%",
        minWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        backgroundColor: theme.color.white,
        lineHeight: `${condensed ? 28 : exports.rowHeight}px`,
        padding: `0 ${theme.space.content}px`,
        textAlign: align,
        display: "flex",
        alignItems: "center",
        outline: "none",
        color: disabled ? theme.color.text.disabled : theme.color.text.default,
        cursor: disabled ? "initial" : "pointer",
        "&[aria-selected='true']": {
            outline: "none",
        },
        "&:hover, &:focus, &[aria-selected='true']": {
            backgroundColor: theme.color.background.lightest,
        },
    };
});
const Title = styled_1.default("p") `
  font-weight: bold;
  color: ${({ theme }) => theme.color.text.dark};
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  width: 100%;
`;
const Description = styled_1.default("p") `
  margin: 0;
  color: ${({ theme }) => theme.color.text.lighter};
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
`;
const ContentContainer = styled_1.default("div") `
  line-height: ${({ theme }) => theme.font.lineHeight};
  padding: ${({ theme }) => theme.space.content}px 0;
  width: calc(100% - ${({ theme }) => theme.space.content}px);
`;
const ContextMenuIconBase = styled_1.default("div", { shouldForwardProp: prop => prop !== "iconLocation" }) `
  flex: 0 1 auto;
  height: 100%;
  margin-left: ${({ iconLocation }) => (iconLocation && iconLocation === "right" ? "auto" : 0)};
  & svg {
    vertical-align: text-bottom;
  }
`;
const Content = ({ value }) => {
    // Fragments are required to hint to the compiler that these are valid types.
    if (typeof value === "string") {
        return React.createElement(React.Fragment, null, value);
    }
    if (typeof value.description === "undefined") {
        return React.createElement(React.Fragment, null, value.label);
    }
    return (React.createElement(ContentContainer, null,
        React.createElement(Title, null, value.label),
        React.createElement(Description, null, value.description)));
};
const ContextMenuItemIcon = ({ iconLocation, item }) => {
    // If item is just a string,
    if (typeof item === "string") {
        return null;
    }
    // If it's an object with an icon property
    if (typeof item.icon === "function") {
        return (React.createElement(ContextMenuIconBase, { iconLocation: iconLocation }, React.createElement(item.icon, {
            left: iconLocation === "left" || !iconLocation,
        })));
    }
    // If it's an object with a React Element as a property
    return React.createElement(React.Fragment, null, item.icon);
};
const ContextMenuItem = (_a) => {
    var { iconLocation, item, onClick, condensed } = _a, props = __rest(_a, ["iconLocation", "item", "onClick", "condensed"]);
    return (React.createElement(Container, Object.assign({}, props, { onClick: onClick, condensed: condensed, item: item }),
        (!iconLocation || iconLocation === "left") && React.createElement(ContextMenuItemIcon, { iconLocation: iconLocation, item: item }),
        React.createElement(Content, { value: item }),
        iconLocation === "right" && React.createElement(ContextMenuItemIcon, { iconLocation: iconLocation, item: item })));
};
exports.default = ContextMenuItem;
//# sourceMappingURL=ContextMenu.Item.js.map